import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Cdr } from "../_types/cdr";

@Injectable({
    providedIn: 'root',
})

export class CdrService extends Service<Cdr> {
  public override type = 'cdr';
  public override url = 'Voip/cdr'; 
  
  getDispositions(){
      let data = [
          { label: 'Contestada', value: 'ANSWERED', severity: 'success' },
          { label: 'No contestada', value: 'NO ANSWER', severity: 'danger' },
          { label: 'Ocupada', value: 'BUSY', severity: 'warn' },
          { label: 'Fallida', value: 'FAILED', severity: 'danger' }
      ];
      return data;
  }

  getCallTypes(){
      let data = [
          { label: 'Operario a tramitador', value: 'worker-processor' },
          { label: 'Automática', value: 'automation' },
          { label: 'Interna', value: 'internal' },
          { label: 'Externa', value: 'external' }
      ];
      return data;
  }

    getLastApps(){
        let data = [
            { label: 'Cola', value: 'Queue' },
            { label: 'Directo', value: 'Dial' },
            { label: 'Transferencia', value: 'Transfer' },
        ];
        return data;
    }

}
